import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import { DiscountCodeCategoryPropType } from '../proptypes/DiscountCodeProptypes';
import IsActive from '../../../../common/cells/IsActive';

const DiscountCodeCategoryBasicInformationResource = ({
  discountCodeCategory,
}) => {
  const { name, description, active } = discountCodeCategory || {};

  return (
    <>
      <ResourceProperty label="Nombre:">{name || '-'}</ResourceProperty>
      <ResourceProperty label="Descripción:">
        {description || '-'}
      </ResourceProperty>
      <ResourceProperty label="active:">
        <IsActive value={active} />
      </ResourceProperty>
    </>
  );
};

DiscountCodeCategoryBasicInformationResource.propTypes = {
  discountCodeCategory: DiscountCodeCategoryPropType,
};

DiscountCodeCategoryBasicInformationResource.defaultProps = {
  discountCodeCategory: null,
};

export default DiscountCodeCategoryBasicInformationResource;
